import { ApiSuccess } from "@/interfaces/common/Success";
import { api } from "@/services/api";

export async function updateUserExpoToken(userId: string, token: string) {
  await api.put(`/usuarios/${userId}`, {
    token_expo: token,
  });
}

export async function requestRecoveryPassword(email: string) {
  const { data } = await api.post<ApiSuccess>("/usuarios/solicitar-alteracao-senha", { email });
  return data;
}

export async function validateRecoveryPassCode(code: string) {
  const { data } = await api.post<ApiSuccess>("/usuarios/validar-codigo-acesso", { codigo: code });
  return data;
}

export async function updatePassword({ code, password }: { code: string; password: string }) {
  const { data } = await api.post<ApiSuccess>("/usuarios/alterar-senha", {
    codigo: code,
    nova_senha: password,
  });
  return data;
}

export async function changePassword(userId: string, password: string) {
  await api.put<void>(`/usuarios/${userId}`, {
    senha: password,
  });
}
